import { RefreshCw } from "lucide-react";

function DeliveryRow({ label, res }) {
  const s = res?.status;
  const map = {
    sent: { t: "Sent", c: "text-[#2E6B4F]" },
    failed: { t: "Failed", c: "text-[#9C3A3A]" },
    not_configured: { t: "Not configured", c: "text-[#B07B2E]" },
    skipped: { t: "Skipped", c: "text-[#8A877F]" },
  };
  const m = map[s] || { t: s || "—", c: "text-[#8A877F]" };
  return (
    <div className="flex items-center justify-between text-sm" data-testid={`delivery-${label.toLowerCase()}`}>
      <span className="text-[#5C5A54]">{label}</span>
      <span className={m.c}>
        {m.t}{res?.error && s !== "sent" ? ` — ${res.error}` : ""}
      </span>
    </div>
  );
}

// Creator-only panel showing counterparty email/SMS delivery status + a resend action.
export default function NotifyStatus({ delivery, busy, onResend }) {
  if (!delivery) return null;
  const hasProblem =
    delivery.email?.status === "failed" ||
    delivery.sms?.status === "failed" ||
    delivery.email?.status === "not_configured";
  return (
    <div data-testid="notify-status" className="mt-6 bg-white border border-[#DEDBD3] rounded-lg p-5">
      <div className="flex items-center justify-between">
        <p className="overline text-[#5C5A54]">Counterparty notifications</p>
        <button
          data-testid="resend-notify-btn"
          disabled={busy}
          onClick={onResend}
          className="text-sm text-[#1B4D3E] hover:underline flex items-center gap-1 disabled:opacity-50"
        >
          <RefreshCw size={14} /> Resend
        </button>
      </div>
      <div className="mt-3 space-y-2">
        <DeliveryRow label="Email" res={delivery.email} />
        <DeliveryRow label="SMS" res={delivery.sms} />
      </div>
      {hasProblem && (
        <p className="mt-3 text-xs text-[#B07B2E]">
          Some notifications didn't go out. Check the address/number or try Resend once the service is configured.
        </p>
      )}
    </div>
  );
}
